import { Component, DoCheck, Input, KeyValueDiffer, KeyValueDiffers } from '@angular/core';
import { FormControl, ValidatorFn } from '@angular/forms';
import * as _ from 'lodash';
import { debounceTime, distinctUntilChanged, pairwise } from 'rxjs/operators';
import { IControlInput } from '../../shared/models/device';

@Component({
    selector: 'dl-text-number-sensor',
    templateUrl: './text-number-sensor-input.component.html'
})
export class TextNumberSensorInputComponent implements DoCheck {
    public static $name: string = 'textNumberSensor';

    @Input() units: string;
    @Input() step: string;
    @Input() deviceInput: IControlInput;
    @Input() inputFormControl: FormControl;
    @Input() private getValidators: () => ValidatorFn[];
    @Input() private invokeCommand: () => void;

    private readonly debounceTime = 300;

    private differ: KeyValueDiffer<string, any>;

    constructor(private differs: KeyValueDiffers) {
        this.differ = this.differs.find({}).create();
    }

    public ngOnInit() {
        this.inputFormControl.valueChanges.pipe(debounceTime(this.debounceTime), distinctUntilChanged(), pairwise())
            .subscribe(([prev, next]) => {
                this.invokeCommand();
            });
    }

    public ngDoCheck(): void {
        const change = this.differ.diff(this.deviceInput);
        if (change && this.inputFormControl) {
            this.inputFormControl.setValidators(this.getValidators());
            this.inputFormControl.updateValueAndValidity();
        }
    }

    public onBlur() {
        if (_.isFunction(this.deviceInput.$onBlur)) {
            this.deviceInput.$onBlur();
        }
    }
}
